import React from 'react';
import { Row, Col, Form } from "react-bootstrap";
import Select from 'react-select';
import Accordion from 'react-bootstrap/Accordion';

const SoftwareAssets = ({ t, routerSettings, selectedEntity,analystAdminsList, loading, isAdmin }) => {
  const handleSelectChange = (field) => (selectedOption) => {
    selectedEntity(prevAssignments => ({
      ...prevAssignments,
      [field]: selectedOption
    }));
  };

  return (
    <Accordion defaultActiveKey="" className="accordionBody">
      <Accordion.Item eventKey="2">
        <Accordion.Header>{t("Software Assets")}</Accordion.Header>
        <Accordion.Body>
          {loading ?    <div
            className="dt-field dt-skeleton"
            style={{ width: "100%", height: "100px" }}
          ></div>
          :
          <Row className="mb-3">
            <Col sm="4">
              <Form.Label>{t("Assign assets to")}</Form.Label>
              <Select
                options={analystAdminsList}
                value={routerSettings.defaultSoftwareOwner}
                onChange={handleSelectChange('defaultSoftwareOwner')}
                placeholder={t("Select...")}
                isDisabled={!isAdmin}
              />
            </Col>
            <Col sm="4">
              <Form.Label>{t("Assign risks to")}</Form.Label>
              <Select
                options={analystAdminsList}
                value={routerSettings.defaultSoftwareRiskOwner}
                onChange={handleSelectChange('defaultSoftwareRiskOwner')}
                placeholder={t("Select...")}
                isDisabled={!isAdmin}
              />
            </Col>
            <Col sm="4">
              <Form.Label>{t("Assign tasks to")}</Form.Label>
              <Select
                options={analystAdminsList}
                value={routerSettings.defaultSoftwareTaskOwner}
                onChange={handleSelectChange('defaultSoftwareTaskOwner')}
                placeholder={t("Select...")}
                isDisabled={!isAdmin}
              />
            </Col>
          </Row>
          }
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
  );
};

export default SoftwareAssets;
